export default {
"login": "wesbos",
"id": 176013,
"node_id": "MDQ6VXNlcjE3NjAxMw==",
"avatar_url": "https://avatars.githubusercontent.com/u/176013?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/wesbos",
"html_url": "https://github.com/wesbos",
"followers_url": "https://api.github.com/users/wesbos/followers",
"following_url": "https://api.github.com/users/wesbos/following{/other_user}",
"gists_url": "https://api.github.com/users/wesbos/gists{/gist_id}",
"starred_url": "https://api.github.com/users/wesbos/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/wesbos/subscriptions",
"organizations_url": "https://api.github.com/users/wesbos/orgs",
"repos_url": "https://api.github.com/users/wesbos/repos",
"events_url": "https://api.github.com/users/wesbos/events{/privacy}",
"received_events_url": "https://api.github.com/users/wesbos/received_events",
"type": "User",
"site_admin": false,
"name": "Wes Bos",
"company": "me",
"blog": "www.wesbos.com",
"location": "Hamilton, Ontario",
"email": null,
"hireable": true,
"bio": "I create courses that make learning things like JavaScript easy and fun 🔥",
"twitter_username": null,
"public_repos": 346,
"public_gists": 68,
"followers": 31344,
"following": 31,
"created_at": "2010-01-04T10:11:44Z",
"updated_at": "2023-07-04T17:28:36Z"
}
